module.exports = __webpack_public_path__ + "components/profile/static/icon-user-a34e8ace263314d52c2085aec5e75039.svg";